import { render } from "./AnncCard.vue?vue&type=template&id=2310e441&scoped=true"
import script from "./AnncCard.vue?vue&type=script&lang=js"
export * from "./AnncCard.vue?vue&type=script&lang=js"

import "./AnncCard.vue?vue&type=style&index=0&id=2310e441&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2310e441"]])

export default __exports__